module.exports = __webpack_public_path__ + "img/DJ.247462d5.png";